// Resource links for the Support page. Per the content rules, we don't
// invent documentation URLs — anything without a confirmed destination
// is marked unavailable and shown with a note instead of a dead link.

export type SupportResource = {
  label: string;
  href?: string;
  available: boolean;
};

export const supportResources: SupportResource[] = [
  { label: "Knowledge Base", available: false },
  { label: "Service Status", available: false },
  { label: "Documentation", available: false },
  { label: "Network Information", available: false },
  { label: "Announcements", available: false },
];
